enum CarouselEffect {
  COVERFLOW = 'coverflow',
}

export { CarouselEffect };
